/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S1_P3_PreInputs */

const tr_iade_iptal_s1_p3_pre = /** @type {(inputs: Iade_Iptal_S1_P3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politika,`)
};

const en_iade_iptal_s1_p3_pre = /** @type {(inputs: Iade_Iptal_S1_P3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Policy is an integral annex to the`)
};

const de_iade_iptal_s1_p3_pre = /** @type {(inputs: Iade_Iptal_S1_P3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Richtlinie ist ein untrennbarer Anhang des Dokuments`)
};

const ru_iade_iptal_s1_p3_pre = /** @type {(inputs: Iade_Iptal_S1_P3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика является неотъемлемым приложением к документу`)
};

/**
* | output |
* | --- |
* | "The Policy is an integral annex to the" |
*
* @param {Iade_Iptal_S1_P3_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s1_p3_pre = /** @type {((inputs?: Iade_Iptal_S1_P3_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S1_P3_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s1_p3_pre(inputs)
	if (locale === "de") return de_iade_iptal_s1_p3_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s1_p3_pre(inputs)
	return tr_iade_iptal_s1_p3_pre(inputs)
});